import { Box, Button, Card, makeStyles, styled, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const ImageItemCont = styled(Card)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  // maxHeight: 144,
  borderRadius: 8,
  margin: 10,
  transition: '300ms',
  position: 'relative',
  cursor: 'pointer',
  '&:hover': {
    transform: 'scale(1.1)',
    // '& $img-item-hover': {
    //   color: 'purple',
    // },
  },
}));

export const ImageElement = styled('img')(({ theme }) => ({
  maxHeight: 144,
  borderRadius: 10,
  // maxWidth: 200,
  minWidth: 50,
  minHeight: 144,
  transition: '500ms ease',
  // maxHeight: 200,
}));

export const VideoItemCont = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxHeight: 214,
  maxWidth: 333,
  minHeight: 214,
  minWidth: 333,
  borderRadius: 8,
  margin: 10,
  '& .profile-video-item': {
    width: '100%',
    borderRadius: 10,
  },
  position: 'relative',
  [theme.breakpoints.down(960)]: {
    maxHeight: 'unset',
    maxWidth: 'unset',
    minHeight: 'unset',
    minWidth: 'unset',
    margin: '0 0 20px 0',
  },
}));

export const AudioItemCont = styled('div')(({ theme }) => ({
  display: 'flex',
  height: 53,
  borderRadius: 8,
  backgroundColor: theme.palette.type === 'dark' ? '#18212e' : COLORS.LIGHT_BORDER,
  margin: 10,
  alignItems: 'center',
  padding: '0px 15px',
  cursor: 'pointer',
  position: 'relative',

  [theme.breakpoints.down(960)]: {
    width: '100%',
    margin: '0 0 15px 0',
  },
}));

export const AudioInfo = styled(Box)(({ theme }) => ({
  marginLeft: 15,
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  width: 200,
}));

export const AudioName = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: 170,
  flex: 1,
  overflow: 'hidden',
}));

export const Duration = styled(Box)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
}));

export const CheckNumberCont = styled(Box)(({ theme }) => ({
  color: COLORS.WHITE,
  marginLeft: 'auto',
  height: 24,
  width: 24,
  backgroundColor: '#3e8bff',
  borderRadius: 3,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const DragCont = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : COLORS.GRAY,
  position: 'absolute',
  top: '5px',
  right: '5px',
  display: 'flex',
  padding: 2,
  borderRadius: 8,
  filter: 'blur(.5)',
  zIndex: 10,
  cursor: 'move',
}));

export const EditCont = styled('div')(({ theme }) => ({
  backgroundColor: COLORS.PRIMARY,
  position: 'absolute',
  bottom: '5px',
  left: '5px',
  display: 'flex',
  padding: 5,
  borderRadius: 3,
  zIndex: 10,
}));

export const AudioDrag = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: '13px',
  display: 'flex',
  padding: 5,
  borderRadius: 8,
  filter: 'blur(.5)',
  zIndex: 10,
  cursor: 'move',
}));

export const ProgressOverlay = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#00000099' : '#edf1f699',
  position: 'absolute',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 99,
}));

export const useStyles = makeStyles((theme) => ({
  circle: {
    stroke: 'url(#linearColors)',
    position: 'absolute',
  },
  toolTip: {
    color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.PRIMARY,
    border: '2px solid',
    borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
    background: theme.palette.type === 'dark' ? '' : COLORS.WHITE,
  },
}));
